import toast from "toasted-notes";
import "toasted-notes/src/styles.css";

import {
  LOAD_USER,
  USER_LOAD_SUCCESS,
  REGISTER_USER,
  REGISTER_SUCCESS,
  REGISTER_FAIL,
} from "../../actions/user/types";

const initialState = {
  userList: [],
  register: null,
  loading: false,
};

export const users = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case LOAD_USER:
      return {
        ...state,
        userList: payload,
        loading: true,
      };
    case USER_LOAD_SUCCESS:
      return {
        ...state,
        userList: payload,
        loading: false,
      };
    case REGISTER_USER:
      return {
        ...state,
        register: payload,
        loading: true,
      };
    case REGISTER_SUCCESS:
      toast.notify("New user created successfully!", {
        position: "bottom-right",
      });
      return { ...state, register: payload, loading: false, error: null };
    case REGISTER_FAIL:
      return { ...state, error: payload, loading: false };
    default: {
      return state;
    }
  }
};
